// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3tepA","header":"MergedInvoice_header__3xl_h"};